import login3 from './login3'
import collect3 from './collect3'
import reconnect3 from './reconnect3'
import setUserPersistentProfile3 from './setUserPersistentProfile3'
import refreshToken from './refreshToken'
import cancelLogin from './cancelLogin'


const user3 =  {
    login3,
    collect3,
    reconnect3,
    setUserPersistentProfile3,
    refreshToken,
    cancelLogin
};

export default user3